var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownloadBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Arrow Download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M13.6873 15.3752C13.998 15.3751 14.25 15.6269 14.25 15.9375C14.25 16.2482 13.9983 16.5001 13.6877 16.5002L3.93766 16.503C3.627 16.5031 3.375 16.2513 3.375 15.9407C3.375 15.63 3.62668 15.3781 3.93734 15.378L13.6873 15.3752ZM8.73617 1.50904L8.8125 1.50391C9.09727 1.50391 9.33262 1.71552 9.36987 1.99008L9.375 2.06641L9.37425 12.3302L12.1656 9.53991C12.3653 9.34023 12.6778 9.32211 12.898 9.48552L12.9611 9.53999C13.1608 9.73971 13.1789 10.0522 13.0155 10.2724L12.961 10.3355L9.21279 14.0829C9.01318 14.2825 8.70089 14.3007 8.4807 14.1376L8.41761 14.0832L4.66502 10.3357C4.4452 10.1162 4.44496 9.76004 4.66448 9.54022C4.86404 9.34038 5.17653 9.32202 5.39685 9.48526L5.45998 9.53968L8.24925 12.3249L8.25 2.06641C8.25 1.78163 8.46162 1.54629 8.73617 1.50904L8.8125 1.50391L8.73617 1.50904Z",
    fill: "#222729"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadBlack);
export default __webpack_public_path__ + "static/media/icon-download-black.61cb893a2cb4accaed6537a6c06acacd.svg";
export { ForwardRef as ReactComponent };